export class UnauthorizedError extends Error {
    constructor(error: Error) {
        super(error.message)
        this.cause = error.cause
        this.name = "UnauthorizedError"
        Object.setPrototypeOf(this, UnauthorizedError.prototype)
    }
}
